if (!customElements.get("cart-progress")) {
    customElements.define(
      "cart-progress",
      class CartProgress extends HTMLElement {
        constructor() {
          super();
          this.themeCurrency = themeVendor.themeCurrency;
  
          this.freeShippingLimit = this.getAttribute("data-fs-limit") ;
          this.freeGiftLimit = this.getAttribute("data-fg-limit") ;
          this.cartMessage = this.querySelector("[data-message]");
  
          this.rate = Shopify.currency.rate;
          this.progress = this.querySelector("[data-progress]");
          this.progressAchieve = this.querySelector("[data-progress-achieve]");
          this.leftToSpendFS = this.querySelector("[data-left-to-spend-fs]");
          this.leftToSpendFG = this.querySelector("[data-left-to-spend-fg]");
          this.subtotal = this.dataset.subtotal;
          this.hasGift = this.dataset.hasGift=="true";
          // console.log("hasGift",this.hasGift);
          if (this.cartMessage) {
            this.init();
          }
        }
  
        init() {
          this.cartFreeLimitShipping =
            Number(this.freeShippingLimit)  * this.rate;
          this.cartFreeGiftLimit = Number(this.freeGiftLimit)  * this.rate;
          this.shippingAmount = 0;
          // this.circumference = 28 * Math.PI; // radius - stroke * 4 * PI
  
          this.exchangeRateConversions(
            this.cartFreeLimitShipping,
            this.shippingAmount,
            this.leftToSpendFS
          );
  
          if (this.progress && this.progressAchieve) {
            this.cartBarProgress();
          }
          this.render();
          this.listen();
        }
  
        listen() {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (e) => {
            console.log(e);
            if(e.cartData.item_count != 0) {

              this.subtotal = e.cartData.items_subtotal_price;
              this.render();
            }
          })
          // this.cartUpdateUnsubscriber();
          document.addEventListener(
            "change",
            function (event) {
              // this.cart = event.detail.cart;
            }.bind(this)
          );
        }
  
        render() {
          const totalPrice = this.subtotal;
          this.freeMessageHandle(totalPrice);
  
          if (this.cart && this.subtotal) {
            // Build cart again if the quantity of the changed product is 0 or cart discounts are changed
          }
          this.shippingAmount = totalPrice;
          if (this.cartMessage) {
            this.updateProgress();
          }
        }
  
        freeMessageHandle(total) {
          // 判定处于是否免邮和赠品状态
          this.classList.toggle(
            "is-free-shipping",
            total > this.cartFreeLimitShipping
          );
          if(this.hasGift){
            this.classList.toggle("is-free-gift", total > this.cartFreeGiftLimit);
          }
        }
  
        cartBarProgress(progress = null) {
          // 修改进度条
          if (progress != null) {
            this.progressAchieve.style.width = progress + "%";
          }
        }
  
        updateProgress() {
          // 计算百分比 更新进度
          let newPercentValue;
          
          if(this.hasGift){
            newPercentValue = (this.shippingAmount / this.cartFreeGiftLimit) * 100;
          }else{
            newPercentValue = (this.shippingAmount / this.cartFreeLimitShipping) * 100;
            
          }
          
          //   更新免邮进度
          this.exchangeRateConversions(
            this.cartFreeLimitShipping,
            this.shippingAmount,
            this.leftToSpendFS
          );
          if(this.hasGift){
            //   更新礼物进度
            this.exchangeRateConversions(
              this.cartFreeGiftLimit,
              this.shippingAmount,
              this.leftToSpendFG
            );
          }
          this.cartBarProgress(newPercentValue > 100 ? 100 : newPercentValue);
        }
  
        exchangeRateConversions(
          cartFreeLimitShipping,
          shippingAmount,
          leftToSpendEl
        ) {
          // 计算剩余金额
          const leftToSpend = theme.settings.currency_code_enabled
            ? this.themeCurrency.formatMoney(
                (cartFreeLimitShipping - shippingAmount),
                theme.moneyFormat
              ) + ` ${theme.currencyCode}`
            : this.themeCurrency.formatMoney(
                (cartFreeLimitShipping - shippingAmount),
                theme.moneyFormat
              );
  
          if (leftToSpendEl) {
            leftToSpendEl.innerHTML = leftToSpend.replace(".00", "");
          }
        }
      }
    );
  }
  